import EllosAction from '../../../core/interfaces/ellosAction.interface';
import { ActionTypes } from '../../../core/models/actionTypes';
import { MatchmackingId } from '../interfaces/matchmaking-id';

export function matchmakingIdReducer(state: MatchmackingId, action: EllosAction) {
  switch (action.type) {
    case ActionTypes.MatchmakingId: {
      state = action.payload;
      return state;
    }

    default:
      return state;
  }
}
